import { Navigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import HomePage from '../../containers/HomePage';
import HostCarPage from '../../containers/HostCarPage';
import HomePageSkeleton from '../skeletons/HomePageSkeleton';
import HostCarPageSkeleton from '../skeletons/HostCarPageSkeleton';
import { ADMIN_DEFAULT_LANDING } from '../../../constants/adminNav';
import { roleStore, Role } from '../../../store/roleStore';
import { isServicesSite, isStaysSite } from '../../constants/siteConfig';
import StayTodayPage from '../../containers/StayHostPage/TodayPage';
import StayHomePage from '../../containers/StayGuestPage/StayHomePage';
import ProviderTodayPage from '../../containers/ServiceProviderPage/ProviderTodayPage';
import ServiceHomePage from '../../containers/ServiceGuestPage/ServiceHomePage';

type HomeRouteProps = {
  loading?: boolean;
};

export function HomeRoute({ loading = false }: HomeRouteProps) {
  const { role } = useSnapshot(roleStore);

  if (role === Role.ADMIN) {
    return <Navigate to={ADMIN_DEFAULT_LANDING} replace />;
  }

  // Spec 016: the stays site has its own home and host landing.
  if (isStaysSite()) {
    return role === Role.HOST ? <StayTodayPage /> : <StayHomePage />;
  }

  // Spec 019: the services site's Provider home (Today) and customer home.
  if (isServicesSite()) {
    return role === Role.HOST ? <ProviderTodayPage /> : <ServiceHomePage />;
  }

  if (loading) {
    return role === Role.HOST ? <HostCarPageSkeleton /> : <HomePageSkeleton />;
  }

  return role === Role.HOST ? <HostCarPage /> : <HomePage />;
}
